<app-dropdown
  class="select-input"
  [label]="label"
  [isFullWidth]="fullWidth"
  [isInvalid]="isInvalid"
  [isDisabled]="isDisabled"
>
  <app-menu-input
    searchContent
    inputId="menu-input"
    [name]="label"
    [label]="label"
    [placeholder]="hasPlaceholderOption === false ? placeholder : null"
    [isSearch]="false"
    [selectedOption]="hasPlaceholderOption === true && selectedOption === null ? {label: placeholder, value: null} : selectedOption"
    (searchValueUpdated)="onSelectionChange($event)"
  ></app-menu-input>

  <ul menuContent class="select-dropdown">
    @if(hasPlaceholderOption) {
    <li>
      <button
        type="button"
        (click)="onSelectionChange('')"
        [class.selected]="selectedOption?.value === null"
      >
        {{ placeholder }}
      </button>
    </li>
    }
    <ng-container *ngFor="let group of optionGroup">
      <li *ngFor="let option of group.options">
        <button
          type="button"
          (click)="onSelectionChange(option.value)"
          [class.selected]="selectedOption?.value === option.value"
        >
          {{ option.label }}
        </button>
      </li>
    </ng-container>

    <ng-container *ngFor="let group of disabledGroup">
      <li *ngIf="group">
        <span class="header">{{ disabledLabel }}</span>
      </li>
      <li *ngFor="let option of group.options">
        <span>
          {{ option.label }}
          <lib-icon name="lock"></lib-icon>
        </span>
      </li>
    </ng-container>
  </ul>
</app-dropdown>
